<template>
  <thead>
    <tr class="table_row desktop">
      <th
        v-for="column in columns"
        :width="column.width"
        :key="column.key"
        class="row_title"
        :class="[`${column.key}-header`]"
      >
        <slot :name="column.key" :column="column">
          <app-table-sorter
            v-if="column.sortable"
            :sorting-id="column.key"
            :default-order="defaultSortOrder"
            @sorting-id="$emit('sorting-id', $event)"
            @sorting-order="$emit('sorting-order', $event)"
          >
            {{ $t(column.title.key, column.title.placeholder) }}
          </app-table-sorter>
          <template v-else>
            {{ $t(column.title.key, column.title.placeholder) }}
          </template>
        </slot>
      </th>
    </tr>
  </thead>
</template>

<script setup>
defineOptions({
  name: 'AppTableHeader'
});

const props = defineProps({
  columns: {
    type: Array,
    required: true
  },
  defaultSortOrder: {
    type: String,
    default: 'descending'
  }  
});
</script>
